var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('r-form',_vm._b({ref:"refCFEightColumnsBalance",attrs:{"title":"Generar balance de 8 columnas","reset-text":"reiniciar","submit-text":"generar"},on:{"submit":_vm.submitDownloadEightColumnsBalanceExcel}},'r-form',_vm.formProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }